import React from "react";
import Pagination from "react-js-pagination";
import { NavLink } from "react-router-dom";
import ExpenseTypesMenu from "../expense-types-menu";
const ExpenseTypeStep4Page = props => {
  let data = props;
  return (
    <div>
      <div className="inner-header">
        <div className="shape-header">
          <div className="left">R</div>
          <div className="right">
            <h6 className="heading">Expense Types</h6>
            <p className="text">Lorem Ipsum is simply dummy</p>
          </div>
        </div>
      </div>
      <div className="p-padding">
        <div className="form-holder">
          <ExpenseTypesMenu />
          <div className="table-container">
            <div className="table-responsive">
              <table className="table table table-striped">
                <thead>
                  <tr>
                    <th>Policy name</th>
                    <th>show cost per attendence</th>
                    <th>allow users to edit the cost per attendence</th>
                    <th>allow users to enter the count of no of shows</th>
                    <th>Allow users to edit the count of attendees</th>
                    <th>Include user os an attendee by default </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AU Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>India Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>China Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>LA Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>UK Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>US Expense policy</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" />
                        <span className="slider round" />
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-footer">
              <div className="row">
                <div className="col-md-3">
                  <div className="page-count">
                    <div className="text">Items</div>
                    <div className="count">
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn dropdown-toggle"
                          data-toggle="dropdown"
                        >
                          10
                        </button>
                        <div className="dropdown-menu">
                          <button type="button" className="dropdown-item">
                            10
                          </button>
                          <button type="button" className="dropdown-item">
                            20
                          </button>
                          <button type="button" className="dropdown-item">
                            30
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <Pagination
                    activePage={data.active}
                    itemsCountPerPage={10}
                    totalItemsCount={10}
                    pageRangeDisplayed={3}
                    onChange={data.handlePageChange}
                  />
                </div>
              </div>
              <div className="mt-4">
                <div className="btn-group-margin">
                  <NavLink
                    to="/administration/expense/expense-types-step5"
                    className="btn btn-border-success lg-padding"
                  >
                    Next
                  </NavLink>
                  <button className="btn btn-border-basic lg-padding">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ExpenseTypeStep4Page;
